import { Check, Minus } from "lucide-react";

/**
 * SelectCheckbox — visual tri-state checkbox for admin queues.
 * Uses a real <input> for accessibility; the visible box is styled.
 *
 * Props:
 *   checked, onChange, indeterminate?, testid?, label?
 */
export const SelectCheckbox = ({
  checked, onChange, indeterminate = false, testid, label = "Select",
}) => (
  <label
    className="inline-flex h-6 w-6 shrink-0 cursor-pointer items-center justify-center"
    aria-label={label}
  >
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      data-testid={testid}
      className="peer sr-only"
    />
    <span
      className={`flex h-5 w-5 items-center justify-center rounded-md border-2 transition-colors ${
        checked || indeterminate
          ? "border-ink bg-ink text-sand"
          : "border-border bg-bone text-transparent peer-hover:border-ink"
      }`}
      aria-hidden
    >
      {indeterminate ? (
        <Minus className="h-3 w-3" strokeWidth={3} />
      ) : (
        <Check className="h-3.5 w-3.5" strokeWidth={3} />
      )}
    </span>
  </label>
);
